import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, collection, getDocs, updateDoc, addDoc } from "firebase/firestore";
import { db } from "../../firebase";
import PublicLayout from "../../layouts/PublicLayout";
import emailjs from "emailjs-com";
import ThankYouModal from "../../components/ThankYouModal";
const BookViewing = () => {
    const { propertyId } = useParams();
    const [property, setProperty] = useState(null);
    const [slots, setSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [thankYouModalOpen, setThankYouModalOpen] = useState(false); // Control modal visibility


    // 📄 Data ophalen
    useEffect(() => {
        const fetchAll = async () => {
            const docRef = doc(db, "properties", propertyId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const prop = docSnap.data();
                setProperty(prop);

                if (prop.userId) {
                    const profileRef = doc(db, "users", prop.userId);
                    const profileSnap = await getDoc(profileRef);
                    if (profileSnap.exists()) {
                        setAgentProfile(profileSnap.data());
                    }
                }
            }

            const ref = collection(db, "properties", propertyId, "timeslots");
            const snapshot = await getDocs(ref);
            const data = snapshot.docs
                .map((doc) => ({ id: doc.id, ...doc.data() }))
                .filter((slot) => !slot.booked)
                .sort((a, b) => new Date(`${a.date}T${a.time}`) - new Date(`${b.date}T${b.time}`));
            setSlots(data);
        };

        fetchAll();
    }, [propertyId]);

    const [agentProfile, setAgentProfile] = useState(null);

    useEffect(() => {
        const fetchProperty = async () => {
            const docRef = doc(db, "properties", propertyId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const prop = docSnap.data();
                setProperty(prop);

                // ⬇️ Haal profiel van de makelaar op
                if (prop.userId) {
                    const profileRef = doc(db, "users", prop.userId);
                    const profileSnap = await getDoc(profileRef);
                    if (profileSnap.exists()) {
                        setAgentProfile(profileSnap.data());
                    }
                }
            }
        };

        fetchProperty();
    }, [propertyId]);

    // 📌 Boeking verwerken
    const handleBooking = async () => {
        if (!selectedSlot || !name || !email || !phone) {
            return alert("Vul je naam, telefoonnummer, e-mail en tijdslot in.");
        }

        const slot = slots.find((s) => s.id === selectedSlot);
        if (!slot) return;

        const slotRef = doc(db, "properties", propertyId, "timeslots", selectedSlot);

        await updateDoc(slotRef, {
            booked: true,
            bookedBy: { name, email, phone },
        });

        const bookingRef = await addDoc(collection(db, "bookings"), {
            propertyId,
            slotId: selectedSlot,
            name,
            email,
            telefoon: phone,
            createdAt: new Date(),
        });

        setThankYouModalOpen(true); // Modal openen om te bedanken

        const cancelUrl = `${window.location.origin}/cancel-booking?id=${bookingRef.id}&propertyId=${propertyId}&slotId=${selectedSlot}`;

        const startDateObj = new Date(`${slot.date}T${slot.time}`);
        const endDateObj = new Date(startDateObj.getTime() + 30 * 60 * 1000); // 30 minuten

        const formatGoogleDate = (d) =>
            d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';

        const calendarLink = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=Bezichtiging+${encodeURIComponent(
            property?.address || "woning"
        )}&dates=${formatGoogleDate(startDateObj)}/${formatGoogleDate(
            endDateObj
        )}&details=Je+bezichtiging+bij+Ons+Soort+Makelaars&location=${encodeURIComponent(
            property?.address || ""
        )}`;

        const emailParams = {


            to_name: name,
            to_email: email,
            property_address: property?.address,
            date: slot.date,
            time: slot.time,
            bezoeker_name: name,
            bezoeker_email: email,
            bezoeker_phone: phone,
            makelaar_email: agentProfile?.email,
            makelaar_secondary_email: agentProfile?.secundairEmail,
            cancel_url: cancelUrl,
            calendar_link: calendarLink, // 👈 voeg deze toe
        };

        emailjs
            .send("service_ntniqze", "template_bezoeker", emailParams, "nNp7Bkh5pHebdN7pN")
            .then(() => console.log("E-mail naar bezoeker verzonden ✅"))
            .catch((err) => console.error("Bezoeker mail error:", err));

        emailjs
            .send("service_ntniqze", "template_makelaar", emailParams, "nNp7Bkh5pHebdN7pN")
            .then(() => console.log("E-mail naar makelaar verzonden ✅"))
            .catch((err) => console.error("Makelaar mail error:", err));
    };

    // 📅 Groepeer tijdsloten per datum
    const groupedSlots = slots.reduce((acc, slot) => {
        if (!acc[slot.date]) acc[slot.date] = [];
        acc[slot.date].push(slot);
        return acc;
    }, {});

    return (
        <PublicLayout>
            <div className="p-6 max-w-5xl mx-auto">
                <div className="p-6 border border-gray-200 rounded-lg shadow-xl bg-white flex flex-col md:flex-row gap-8">
                    {/* 📅 Tijdsloten links */}
                    <div className="flex-1">
                        <h1 className="text-2xl font-bold mb-6 text-gray-800 text-center">
                            Plan je bezichtiging voor {property?.address}
                        </h1>

                        {Object.keys(groupedSlots).length === 0 ? (
                            <p className="text-gray-500">Er zijn op dit moment geen beschikbare tijdsloten.</p>
                        ) : (
                            Object.entries(groupedSlots).map(([date, slotList]) => (
                                <div key={date} className="mb-6">
                                    <h2 className="text-lg font-semibold mb-2">📅 {date}</h2>
                                    <div className="grid grid-cols-3 gap-4">
                                        {slotList.map((slot) => (
                                            <button
                                                key={slot.id}
                                                onClick={() => setSelectedSlot(slot.id)}
                                                className={`p-3 border rounded-md text-center transition-all ${
                                                    selectedSlot === slot.id
                                                        ? "bg-[#175151] text-white"
                                                        : "bg-gray-100 hover:bg-gray-200"
                                                }`}
                                            >
                                                {slot.time}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))
                        )}

                        {/* 📬 Formulier */}
                        {selectedSlot && (
                            <div className="space-y-4 mt-4">
                                <input
                                    type="text"
                                    placeholder="Je naam"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="w-full border rounded px-3 py-2"
                                    required
                                />
                                <input
                                    type="tel"
                                    placeholder="Je telefoonnummer"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    className="w-full border rounded px-3 py-2"
                                    required
                                />
                                <input
                                    type="email"
                                    placeholder="Je e-mailadres"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full border rounded px-3 py-2"
                                    required
                                />
                                <button
                                    onClick={handleBooking}
                                    className="w-full p-3 bg-[#175151] text-white font-semibold rounded-lg shadow hover:bg-[#148c87] transition"
                                >
                                    Bevestig afspraak
                                </button>
                                <div>
                                    <h3>Let op! Je ontvangt een mail vanuit @osmakelaars.nl</h3>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Rechterzijde: makelaar info */}
                    <div className="w-full md:w-80 bg-white p-6 border border-gray-200 rounded-lg shadow">
                        {agentProfile?.profielfotoUrl && (
                            <div className="mb-4 text-center">
                                <img
                                    src={agentProfile.profielfotoUrl}
                                    alt="makelaar"
                                    className="w-24 h-24 object-cover rounded-full mx-auto"
                                />
                            </div>
                        )}

                        <ul className="text-sm text-gray-700 space-y-2">
                            <li><strong>Makelaar:</strong> {property?.makelaarNaam}</li>
                            <li><strong>Bedrijf:</strong> {agentProfile?.bedrijf}</li>
                            <li><strong>Telefoon:</strong> {agentProfile?.telefoon}</li>
                            <li><strong>E-mail:</strong> {agentProfile?.email || "Niet beschikbaar"}</li>
                            <li><strong>Vraagprijs:</strong> {property?.vraagprijs}</li>
                            <li><strong>Aangeboden door:</strong> {property?.aangebodenDoor}</li>
                        </ul>

                        {property?.woningFotoUrl && (
                            <div className="mt-4 text-center">
                                <img
                                    src={property.woningFotoUrl}
                                    alt="woning"
                                    className="w-full h-48 object-cover rounded-lg"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <ThankYouModal
                isOpen={thankYouModalOpen}
                onClose={() => setThankYouModalOpen(false)} // Sluit de modal en herlaad de pagina
            />

        </PublicLayout>
    );
};

export default BookViewing;
